import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './pricing6.css'

const Pricing6 = (props) => {
  const [isMonthly, setIsMonthly] = useState(true)
  return (
    <div
      className={`pricing6-pricing23 thq-section-padding ${props.rootClassName} `}
    >
      <div className="pricing6-max-width thq-section-max-width">
        <div className="pricing6-section-title">
          <div className="pricing6-content">
            <h2 className="pricing6-text10 thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="pricing6-text88">Our Services</span>
                </Fragment>
              )}
            </h2>
          </div>
        </div>
        {!isMonthly && (
          <div className="pricing6-container1">
            <div className="pricing6-column1 thq-card">
              <div className="pricing6-price10">
                <div className="pricing6-price11">
                  <span className="pricing6-text11 thq-body-large">
                    {props.plan1 ?? (
                      <Fragment>
                        <span className="pricing6-text95">Basic Plan</span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing6-text12 thq-heading-3">
                    {props.plan1Price ?? (
                      <Fragment>
                        <span className="pricing6-text87">$50</span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {props.plan1Yearly ?? (
                      <Fragment>
                        <span className="pricing6-text70">$500/year</span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing6-list1">
                  <div className="pricing6-list-item10">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature1 ?? (
                        <Fragment>
                          <span className="pricing6-text76">
                            Standard Home Cleaning
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item11">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature2 ?? (
                        <Fragment>
                          <span className="pricing6-text94">
                            Flexible Scheduling
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item12">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature3 ?? (
                        <Fragment>
                          <span className="pricing6-text77">
                            Customized Solutions
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button className="pricing6-button1 thq-button-outline">
                <span className="thq-body-small">
                  {props.plan1Action ?? (
                    <Fragment>
                      <span className="pricing6-text89">Sign Up Now</span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
            <div className="pricing6-column2 thq-card">
              <div className="pricing6-price12">
                <div className="pricing6-price13">
                  <span className="pricing6-text18 thq-body-large">
                    {props.plan2 ?? (
                      <Fragment>
                        <span className="pricing6-text82">Premium Plan</span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing6-text19 thq-heading-3">
                    {props.plan2Price ?? (
                      <Fragment>
                        <span className="pricing6-text66">$80</span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {props.plan2Yearly ?? (
                      <Fragment>
                        <span className="pricing6-text93">$800/year</span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing6-list2">
                  <div className="pricing6-list-item13">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature1 ?? (
                        <Fragment>
                          <span className="pricing6-text63">
                            Deep Cleaning Services
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item14">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature2 ?? (
                        <Fragment>
                          <span className="pricing6-text67">
                            Priority Scheduling
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item15">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature3 ?? (
                        <Fragment>
                          <span className="pricing6-text65">
                            Personalized Cleaning Plans
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item16">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature4 ?? (
                        <Fragment>
                          <span className="pricing6-text99">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button className="pricing6-button2 thq-button-filled">
                <span className="thq-body-small">
                  {props.plan2Action ?? (
                    <Fragment>
                      <span className="pricing6-text61">Sign Up Now</span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
            <div className="pricing6-column3 thq-card">
              <div className="pricing6-price14">
                <div className="pricing6-price15">
                  <span className="pricing6-text26 thq-body-large">
                    {props.plan3 ?? (
                      <Fragment>
                        <span className="pricing6-text81">Ultimate Plan</span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing6-text27 thq-heading-3">
                    {props.plan3Price ?? (
                      <Fragment>
                        <span className="pricing6-text69">$120</span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {props.plan3Yearly ?? (
                      <Fragment>
                        <span className="pricing6-text91">$1200/year</span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing6-list3">
                  <div className="pricing6-list-item17">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature1 ?? (
                        <Fragment>
                          <span className="pricing6-text100">
                            Luxury Home Cleaning
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item18">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature2 ?? (
                        <Fragment>
                          <span className="pricing6-text60">
                            Weekly Cleaning Sessions
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item19">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature3 ?? (
                        <Fragment>
                          <span className="pricing6-text75">
                            Exclusive Add-On Services
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item20">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature4 ?? (
                        <Fragment>
                          <span className="pricing6-text101">
                            Premium feature
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <button className="pricing6-button3 thq-button-filled">
                <span className="thq-body-small">
                  {props.plan3Action ?? (
                    <Fragment>
                      <span className="pricing6-text90">Sign Up Now</span>
                    </Fragment>
                  )}
                </span>
              </button>
            </div>
          </div>
        )}
        {isMonthly && (
          <div className="pricing6-container2">
            <div className="pricing6-column4 thq-card">
              <div className="pricing6-price16">
                <div className="pricing6-price17">
                  <p className="pricing6-text34 thq-body-large">
                    {props.plan11 ?? (
                      <Fragment>
                        <span className="pricing6-text98">
                          Data Solutions and Digital Transformation
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <div className="pricing6-list-item21">
                    <span className="pricing6-text35 thq-body-small">
                      {props.plan1Feature11 ?? (
                        <Fragment>
                          <span className="pricing6-text72">
                            Unlock the potential of your business through
                            innovative data solutions and comprehensive digital
                            transformation strategies. Our focus is on fostering
                            insights that drive value creation, enabling you to
                            achieve your business objectives in a rapidly
                            evolving digital landscape.
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <div className="pricing6-list4">
                  <div className="pricing6-list-item22">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature111 ?? (
                        <Fragment>
                          <span className="pricing6-text64">
                            Professional Services
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item23">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature1111 ?? (
                        <Fragment>
                          <span className="pricing6-text68">
                            Management Consulting
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item24">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature21 ?? (
                        <Fragment>
                          <span className="pricing6-text74">
                            Business Intelligence
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item25">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature31 ?? (
                        <Fragment>
                          <span className="pricing6-text92">
                            Technology Integration
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item26">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature311 ?? (
                        <Fragment>
                          <span className="pricing6-text83">
                            Data Analytics Services
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing6-column5 thq-card">
              <div className="pricing6-price18">
                <div className="pricing6-price19">
                  <p className="pricing6-text41 thq-body-large">
                    {props.plan21 ?? (
                      <Fragment>
                        <span className="pricing6-text57">
                          Strategy &amp; Advisory Services
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <span className="pricing6-text42 thq-body-small">
                    {props.plan2Feature11 ?? (
                      <Fragment>
                        <span className="pricing6-text71">
                          Our strategy and advisory services empower businesses
                          to navigate immediate challenges, foster mid-term
                          innovation, and cultivate long-term sustainable
                          growth. We offer a structured and forward-thinking
                          approach tailored to your needs.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing6-list5">
                  <div className="pricing6-list-item27">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature21 ?? (
                        <Fragment>
                          <span className="pricing6-text96">
                            Data &amp; Infrastructure Gap Assessment
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item28">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature211 ?? (
                        <Fragment>
                          <span className="pricing6-text78">
                            <span>AI Readiness Assessment</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item29">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature31 ?? (
                        <Fragment>
                          <span className="pricing6-text55">
                            Transformation Go-to Plan
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item30">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature312 ?? (
                        <Fragment>
                          <span className="pricing6-text84">
                            Implementation Roadmaps
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item31">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature311 ?? (
                        <Fragment>
                          <span className="pricing6-text73">
                            Strategic Planning Support
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing6-column6 thq-card">
              <div className="pricing6-price20">
                <div className="pricing6-price21">
                  <p className="pricing6-text48 thq-body-large">
                    {props.plan31 ?? (
                      <Fragment>
                        <span className="pricing6-text56">
                          Skills Development &amp; Training
                        </span>
                      </Fragment>
                    )}
                  </p>
                  <span className="pricing6-text49 thq-body-small">
                    {props.plan3Feature11 ?? (
                      <Fragment>
                        <span className="pricing6-text97">
                          Enhance your team&apos;s capabilities with our diverse
                          skills development and training programs. Our expert
                          facilitators customise learning experiences to meet
                          specific client needs, ensuring impactful training
                          outcomes.
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing6-list6">
                  <div className="pricing6-list-item32">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature21 ?? (
                        <Fragment>
                          <span className="pricing6-text62">
                            14+ Tailored Programs
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item33">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature31 ?? (
                        <Fragment>
                          <span className="pricing6-text86">
                            Expert Facilitation
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item34">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature41 ?? (
                        <Fragment>
                          <span className="pricing6-text59">
                            Client-Centric Curriculum Development
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item35">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature412 ?? (
                        <Fragment>
                          <span className="pricing6-text85">
                            Continuous Learning Opportunities
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing6-list-item36">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature411 ?? (
                        <Fragment>
                          <span className="pricing6-text58">
                            Workshops and Seminars
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

Pricing6.defaultProps = {
  plan2Feature31: undefined,
  plan31: undefined,
  plan21: undefined,
  plan3Feature411: undefined,
  plan3Feature41: undefined,
  plan3Feature2: undefined,
  plan2Action: undefined,
  plan3Feature21: undefined,
  plan2Feature1: undefined,
  plan1Feature111: undefined,
  rootClassName: '',
  plan2Feature3: undefined,
  plan2Price: undefined,
  plan2Feature2: undefined,
  plan1Feature1111: undefined,
  plan3Price: undefined,
  plan1Yearly: undefined,
  plan2Feature11: undefined,
  plan1Feature11: undefined,
  plan2Feature311: undefined,
  plan1Feature21: undefined,
  plan3Feature3: undefined,
  plan1Feature1: undefined,
  plan1Feature3: undefined,
  plan2Feature211: undefined,
  plan3: undefined,
  plan2: undefined,
  plan1Feature311: undefined,
  plan2Feature312: undefined,
  plan3Feature412: undefined,
  plan3Feature31: undefined,
  plan1Price: undefined,
  heading1: undefined,
  plan1Action: undefined,
  plan3Action: undefined,
  plan3Yearly: undefined,
  plan1Feature31: undefined,
  plan2Yearly: undefined,
  plan1Feature2: undefined,
  plan1: undefined,
  plan2Feature21: undefined,
  plan3Feature11: undefined,
  plan11: undefined,
  plan2Feature4: undefined,
  plan3Feature1: undefined,
  plan3Feature4: undefined,
}

Pricing6.propTypes = {
  plan2Feature31: PropTypes.element,
  plan31: PropTypes.element,
  plan21: PropTypes.element,
  plan3Feature411: PropTypes.element,
  plan3Feature41: PropTypes.element,
  plan3Feature2: PropTypes.element,
  plan2Action: PropTypes.element,
  plan3Feature21: PropTypes.element,
  plan2Feature1: PropTypes.element,
  plan1Feature111: PropTypes.element,
  rootClassName: PropTypes.string,
  plan2Feature3: PropTypes.element,
  plan2Price: PropTypes.element,
  plan2Feature2: PropTypes.element,
  plan1Feature1111: PropTypes.element,
  plan3Price: PropTypes.element,
  plan1Yearly: PropTypes.element,
  plan2Feature11: PropTypes.element,
  plan1Feature11: PropTypes.element,
  plan2Feature311: PropTypes.element,
  plan1Feature21: PropTypes.element,
  plan3Feature3: PropTypes.element,
  plan1Feature1: PropTypes.element,
  plan1Feature3: PropTypes.element,
  plan2Feature211: PropTypes.element,
  plan3: PropTypes.element,
  plan2: PropTypes.element,
  plan1Feature311: PropTypes.element,
  plan2Feature312: PropTypes.element,
  plan3Feature412: PropTypes.element,
  plan3Feature31: PropTypes.element,
  plan1Price: PropTypes.element,
  heading1: PropTypes.element,
  plan1Action: PropTypes.element,
  plan3Action: PropTypes.element,
  plan3Yearly: PropTypes.element,
  plan1Feature31: PropTypes.element,
  plan2Yearly: PropTypes.element,
  plan1Feature2: PropTypes.element,
  plan1: PropTypes.element,
  plan2Feature21: PropTypes.element,
  plan3Feature11: PropTypes.element,
  plan11: PropTypes.element,
  plan2Feature4: PropTypes.element,
  plan3Feature1: PropTypes.element,
  plan3Feature4: PropTypes.element,
}

export default Pricing6
